/*
|----------------------------------------------------------
|   Podcast:
|---------------------------------------------------------
|   All functions related to Podcasts
|
*/

/**
 * Import config
 */
import config from "./config";

export default {

    /**
     * Helps initialized podcast player.
     * TODO: find a better solution to run functions
     * depending on jQuery Document Ready
     *
     * Requires podcast player scripts loaded in
     * scriptsToInitialize module
     */
    initializePlayer: function() {

        if (config.debug) console.log('Podcast:', 'initializePlayer');

        console.log("pjax time out func start................");

        //WPB-3338
        setTimeout(function(){ try { console.log("pjax readyFn_Emmis_Audio_Player................"); readyFn_Emmis_Audio_Player( jQuery , 'pjax'); }catch(e){ } }, 1000);
        //setTimeout(function(){ try { console.log("pjax get_wpb_now_playing_meta_data................"); get_wpb_now_playing_meta_data(); }catch(e){ } }, 2000);
        setTimeout(function(){ try { console.log("pjax readyFn_Now_Playing_Meta_Data................"); readyFn_Now_Playing_Meta_Data(jQuery , 'pjax'); }catch(e){ } }, 2000);

        // //WPB-3605
        setTimeout(function(){ try { readyFn_BannerAjax( jQuery , 'pjax'); }catch(e){ } }, 2000);

        //WPB-4278
        setTimeout(function(){ try { readyFn_GalleryAjax( jQuery , 'pjax'); }catch(e){ } }, 2000);

        setTimeout(function(){ try { readyFn_jPlayerFunc_BetterAudioStats( jQuery , 'pjax'); }catch(e){ } }, 2000); // /wpb-better-audio-stats/js/wpb-jquery-jplayer.js
        setTimeout(function(){ try { readyFn_jPlayerFunc( jQuery , 'pjax'); }catch(e){ } }, 4000); // /wpb-show-core/modules/jplayer/jquery.jplayer-init-latest.js

        setTimeout(function(){ try { callEqualizer( jQuery , 'pjax'); }catch(e){ } }, 2000);

        //WPB-3776
        //setTimeout(function(){ try { readyFn_SendpressSignup( jQuery , 'pjax'); }catch(e){ } }, 2000); //WPB-4264 -- commenting this as things are working fine without this.
        //setTimeout(function(){ try { callContestCustomQuestions(); }catch(e){ } }, 2000); //WPB-4337 -- commenting this as things are working fine without this.

        //WPB-3762
        setTimeout(function(){ try { readyFn_UGCAjax( jQuery , 'pjax'); }catch(e){ } }, 2000);
        setTimeout(function(){ try { jQuery("#uplodedImages").fileinput(); }catch(e){ } }, 2000);
        setTimeout(function(){ try { jQuery("#uplodedVideo").fileinput(); }catch(e){ } }, 2000);
        setTimeout(function(){ try { jQuery("#uplodedAudio").fileinput(); }catch(e){ } }, 2000);

        //WPB-6780
        setTimeout(function(){ try { readyFn_EventAjax( jQuery , 'pjax'); }catch(e){ } }, 2000);
        setTimeout(function(){ try { readyFn_EventList( jQuery , 'pjax'); }catch(e){ } }, 2000);
        setTimeout(function(){ try { readyFn_TribeEvent( jQuery , 'pjax'); }catch(e){ } }, 2000);

        //-------------------
        //  /events-customize-changes/pjax/events-calendar-pro-new/src/resources/js/widget-calendar.js?ver=4.7.10
        setTimeout(function(){ try { readyFn_Calendar( jQuery , 'pjax'); }catch(e){ } }, 2000);
        //-------------------
        
        setTimeout(function(){ try { readyFn_FilterBar(); }catch(e){ } }, 2000);
        //setTimeout(function(){ try { readyFn_breakpoint(); }catch(e){ } }, 2000);    
        //setTimeout(function(){ try { readyFn_datepicker(); }catch(e){ } }, 2000);

        //-------------------
        //  /wp-content/plugins/events-customize-changes/pjax/events-bar.js?ver=3.6.6
        setTimeout(function(){ try { console.log("here........ readyFn_eventBar "); /*readyFn_eventBar();*/ }catch(e){ } }, 2000);
        //setTimeout(function () { try { if (window.location.href.indexOf("/events") != -1 ) { console.log('here........ readyFn_eventBar '); readyFn_eventBar(); } else { console.log('here........ not readyFn_eventBar called....'); } } catch (e) {} }, 2000);
        //looks like no need now this readyFn_eventBar() but file : /wp-content/plugins/events-customize-changes/pjax/the-events-calendar-new/src/resources/js/views/datepicker.js
        //will do this things to display Now onwards calendar date picker !!
        //-------------------
        
        //setTimeout(function(){ try { readyFn_eventBarInput(); }catch(e){ } }, 2000);

        //setTimeout(function(){ try { readyFn_timepicker(); }catch(e){ } }, 2000); //no need right now timepicker.js pjax add event page.

        //alert(jQuery('#ui-datepicker-div').html());
        setTimeout(function(){ console.log('here........ tribe-datepicker events add page'); try { jQuery('#ui-datepicker-div').remove(); jQuery( '.tribe-datepicker' ).datepicker( tribe_datepicker_opts ); }catch(e){ } }, 2000);

        //WPB-4265
        setTimeout(function(){ try { pjax_check_supergallery_slider( jQuery ); }catch(e){ } }, 2000);
        setTimeout(function(){ try { pjax_supergallery_flexslider_height( jQuery ); }catch(e){ } }, 2000);

        //WPB-4544
        //setTimeout(function(){ try { /*if(navigator.userAgent.indexOf("Firefox") != -1 ) { }else {*/ swiper = new Swiper( jQuery('.ee-swiper__container'), window.swiperArgs_pjax ); /*}*/ }catch(e) { console.log(e.message); } }, 2000);
        setTimeout(function () {
            try {
                //swiper = new Swiper(jQuery(".ee-swiper__container"), window.swiperArgs_pjax);

                var icnt = 0;
                jQuery('.ee-swiper__container').each(function() {
                    var currentElement = jQuery(this);
                    swiper = new Swiper(currentElement, window.swiperArgs_pjax_arr[icnt]);

                    icnt++;
                });
            } catch (e) {
                //alert(e.message);
            }
        }, 2000);


        //WPB-4370
        //setTimeout(function(){ try { if(jQuery('#ele_on_air_show_div').length>0){ refreshShowDiv()} }catch(e){ } }, 2000);
        //WPB-4325
        setTimeout(function(){ try { jQuery('.ele_on_air_show_div_class').each(function() { var currentElement = $(this); var id_div = currentElement.prop('id'); var resArr = id_div.split("_"); var uniqueId = resArr[resArr.length - 1] ; eval('refreshShowDiv_'+uniqueId+'()'); }); }catch(e){ } }, 2000);

        //WPB-4363
        setTimeout(function(){ try { checkForMember()}catch(e){ }}, 2000);

        //WPB-4549
        setTimeout(function(){ try { gaCustomDimensionPjax(); }catch(e){ } }, 2000);

         //WPB-5679
        setTimeout(function(){ try {  pauseStreamPlayer(); }catch(e){ } }, 2000);
        setTimeout(function(){ try {  pauseJPlayer(); }catch(e){ } }, 2000);

        //WPB-5777
        setTimeout(function(){ try {  copyEpisodeURLFromButtonClick(); }catch(e){ } }, 2000);

        //===========================
        //WPB-5019 -- pjax.....
        jQuery(".thickbox").click(function(){
            var data_lightbox = jQuery(".thickbox").attr('data-lightbox');
            console.log('data_lightbox : '+data_lightbox);
            if (data_lightbox == 'wpbdpgal') {
                setTimeout(function(){
                    //id = elementor-lightbox-slideshow-single-img

                    jQuery('.dialog-lightbox-widget-content').css({top: '0px', left: '0px'}); 

                    jQuery('.swiper-wrapper').css({transform: 'translate3d(0px, 0px, 0px)'});

                    var divWidth = jQuery('#elementor-lightbox-slideshow-single-img').width();

                    jQuery('.elementor-lightbox-item').css({width: divWidth+'px'}); 
                    jQuery('.elementor-lightbox-item').css('margin-right','100px');

                    jQuery('.elementor-lightbox-image').attr('src',jQuery('.elementor-lightbox-image').attr('data-src'));
                    jQuery('.elementor-lightbox-image').addClass( "swiper-lazy-loaded" );

                    jQuery('.swiper-lazy-preloader').hide();
                }, 1000);
            }
            else {
                console.log('data_lightbox not found.');
            }
        });
        //===========================
        //WPB-5712
        setTimeout(function(){ try { 
            jQuery('.ginput_container_phone input').mask('(999) 999-9999').bind('keypress', 
                function(e){
                    if(e.which == 13){
                        Query(this).blur();
                    } 
                } 
              );
            } catch(e){ } }, 2000);
        //===========================

        //WPB-5958
         setTimeout(function(){ try{ readyFn_EventAjax( jQuery , 'pjax'); }catch(e){ } }, 2000);


        //WPB-6432
    setTimeout(function(){ try{ readyFn_recaptcha() }catch(e){ } }, 2000);
  },

    /**
    * Keeping this scripts for testing only.
    */
    scripts: '<script src="/wp-content/plugins/wpb-show-core/modules/jplayer/jquery.jplayer.js"></script><script src="/wp-content/plugins/wpb-show-core/modules/jplayer/jquery.android-adapter-fix.js"></script><script src="/wp-content/plugins/wpb-show-core/modules/jplayer/jquery.jplayer-init-latest.js"></script><script src="/wp-content/plugins/wpb-ssl-podcast/public/js/wpb-ssl-podcast-public.js"></script>'

}
